import { CheckRideScheduleHoldEntity } from "../../../meta-data/app-meta-data.service";

export interface ScheduleHoldRequest {
    RequestAction: ScheduleHoldRequestAction;
    CheckRideScheduleHold: CheckRideScheduleHoldEntity;
}

export enum ScheduleHoldRequestAction {
    startHold = 0,
    extendHold = 1,
    cancelHold = 2,
}